export const Version = {
    "version": "1.70.0-dev.55.856"
}
